import { claimDailyGift } from '@bonanza-social/daily-gift';
import {
  dailyRewardCollected,
  fetchDailyRewards,
} from '@bonanza-social/daily-rewards/state';
import { dailyMetaGameCompleted } from '@bonanza-social/meta-games';
import { statusChanged } from '@bonanza-social/status';
import {
  accountStatusUpdated,
  isAnyOf,
  startListening,
} from '@bonanza-social/toolkit/state';

startListening({
  actionCreator: dailyMetaGameCompleted,
  effect: async ({ payload }, { dispatch }) => {
    const result = await dispatch(fetchDailyRewards());
    if (fetchDailyRewards.fulfilled.match(result)) {
      const dailyReward = result.payload.dailyRewards.find(
        (reward) => reward.type === payload,
      );

      if (dailyReward?.status === 'Awarded') {
        dispatch(dailyRewardCollected(dailyReward));
      }
    }
  },
});

startListening({
  actionCreator: claimDailyGift.fulfilled,
  effect: async (_, { dispatch }) => {
    const result = await dispatch(fetchDailyRewards());
    if (fetchDailyRewards.fulfilled.match(result)) {
      const dailyReward = result.payload.dailyRewards.find(
        (reward) => reward.type === 'DailyGift',
      );

      if (dailyReward?.status === 'Awarded') {
        dispatch(dailyRewardCollected(dailyReward));
      }
    }
  },
});

startListening({
  matcher: isAnyOf(accountStatusUpdated, statusChanged),
  effect: (_, { dispatch }) => {
    dispatch(fetchDailyRewards());
  },
});
